module.exports = __webpack_public_path__ + "img/vol05_cup01_cover03.e9cc48b7.jpg";